import { ReduxState } from '~/redux/createRootReducer'
import { User } from '~/account/model/reducer'

export const selectUser = (state: ReduxState): { user: User } => ({
  user: state.account.user || {},
})
